import { Close, Edit } from '@material-ui/icons';
import { CourseResultModel } from 'apiServices/controllers/course';
import React from 'react';
import classes from '../course-group-overview.module.scss';

interface CourseGroupOverviewActionsProps {
  item: CourseResultModel;
  key: number;
  onEdit: (item: CourseResultModel, key: number) => void;
  onDelete: (item: CourseResultModel, key: number) => void;
}

export const CourseGroupOverviewActions = ({
  onEdit, onDelete, item, key,
}: CourseGroupOverviewActionsProps) => (
  <div style={{ display: 'flex', marginLeft: '1em' }} className="actions-right">
    <button
      className={classes.button}
      type='button'
      onClick={(e) => {
        onEdit(item, key);
        e.preventDefault();
      }}>
      <Edit />
    </button>
    <button
      className={classes.button_left}
      type='button'
      onClick={(e) => {
        onDelete(item, key);
        e.preventDefault();
      }}>
      <Close />
    </button>
  </div>
);
